'use client';
import dev from '@/assets/images/career/dev.svg';
import uxui from '@/assets/images/career/uxui.png';
import data from '@/assets/images/career/data.png';
import business from '@/assets/images/career/business.png';
import { mapModifiers, notify } from '@/utils/funtion';
import 'swiper/css';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import Image from 'next/image';
import Button from '@/components/atoms/button';
import Input from '@/components/atoms/Input';
import { useState } from 'react';
import Upload from '@/components/atoms/upload';
import Collapse from '@/components/atoms/collapse';
import { applyCV } from '@/services/apis/modules/banner';

const CareerModule = () => {
  const items = [
    {
      key: '1',
      label: (
        <CareerCard
          name="Nhà phát triển web"
          desc="Xây dựng các ứng dụng web Front-end và hệ thống Back-end nhằm giải phóng sức mạnh dữ liệu."
          image={dev}
        />
      ),
      children: <CareerCardContent type="dev" />,
    },
    {
      key: '2',
      label: (
        <CareerCard
          name="Nhà thiết kế web"
          desc="Thiết kế bố cục tổng thể, giao diện người dùng (UI), trải nghiệm người dùng (UX) và tính thẩm mỹ."
          image={uxui}
        />
      ),
      children: <CareerCardContent type="uxui" />,
    },
    {
      key: '3',
      label: (
        <CareerCard
          name="Nhà phân tích dữ liệu"
          desc="Thu nhập dữ liệu kinh tế từ các nguồn khác nhau, sau đó xử lý, làm sạch, hệ thống hóa và viết bình luận."
          image={data}
        />
      ),
      children: <CareerCardContent type="data" />,
    },
    {
      key: '4',
      label: (
        <CareerCard
          name="Nhà phát triển kinh doanh"
          desc="Làm việc trong môi trường có nhiều cơ hội tuyệt vời để tương tác với cơ sở khách hàng đa dạng."
          image={business}
        />
      ),
      children: <CareerCardContent type="business" />,
    },
  ];

  return (
    <div className={mapModifiers('p-career')}>
      <div className="p-career-wrapper">
        <div className="career-title page-title">
          Cơ hội <span>nghề nghiệp</span>
          <div className="line"></div>
        </div>
        <div className="career-overview">
          <p>
            Trong kỷ nguyên số, dữ liệu không đơn giản là những mảnh ghép của
            con số mà nó là mật mã chứa đựng nhiều thông tin về những điều mới
            mẻ, tri thức và cơ hội; và phân tích dữ liệu cũng không phải chỉ là
            những phép tính cộng trừ trên những con số, mà nó là kỹ năng tạo lợi
            thế và là động lực thúc đẩy sự khám phá, sáng tạo, chuyển đổi và
            tăng trưởng.
          </p>
          <p>
            Khi chúng ta ngày càng tiến sâu vào sự phức tạp của thế giới kỹ
            thuật số, vai trò của dữ liệu trong việc định hình chiến lược, chính
            sách, khám phá các chân trời hiểu biết mới và thúc đẩy đổi mới ngày
            càng tăng nhanh theo cấp số nhân. Đích đến cuối cùng của nó là làm
            sao để con người có được cuộc sống ngày càng tốt đẹp hơn.
          </p>
          <p>
            Để thực hiện sứ mệnh và hiện thực hóa tầm nhìn của mình, Vietstats
            chào đón các ứng viên từ khắp nơi cùng tham gia và đồng hành với
            Vietstats trong môi trường chuyên nghiệp, tin cậy, năng động và sáng
            tạo nhất. Tại Vietstats, chúng tôi coi trọng sự đổi mới, tinh thần
            đồng đội và theo đuổi sự xuất sắc. Vietstats đề cao giá trị cá nhân,
            ghi nhận sự đóng góp kịp thời và vinh danh dấu ấn cá nhân của nhân
            viên.
          </p>
          <p>Dưới đây là những cơ hội nghề nghiệp tại Vietstats: </p>
        </div>
        <div className="career-list">
          <Collapse
            items={items}
            accordion={true}
            defaultActiveKey={['1', '2']}
          />
        </div>
      </div>
    </div>
  );
};

export default CareerModule;

const CareerCard = ({
  name,
  image,
  desc,
}: {
  name: string;
  image: string | any;
  desc: string;
}) => {
  return (
    <div className="career-card">
      <div className="left">
        <Image src={image} alt="tab" loading="lazy" />
        <div className="career-card-info">
          <div className="career-card-name">{name}</div>
          <div className="career-card-desc">{desc}</div>
        </div>
      </div>
    </div>
  );
};

const CareerCardContent = ({
  type,
}: {
  type: 'dev' | 'data' | 'uxui' | 'business';
}) => {
  const renderPositionValue = () => {
    switch (type) {
      case 'dev':
        return 'Nhà phát triển web';
      case 'uxui':
        return 'Nhà thiết kế web';
      case 'data':
        return 'Nhà phân tích dữ liệu';
      case 'business':
        return 'Nhà phát triển kinh doanh';
      default:
        return 'Nhà phát triển web';
    }
  };

  const [inputValue, setInputValue] = useState({
    fullName: '',
    email: '',
    phone: '',
    position: renderPositionValue(),
    file: undefined,
  });
  const [isLoading, setLoading] = useState(false);
  //   const now = new Date();
  //   const body = {
  //     fullName: 290000,
  //     email: 'fixed',
  //     phone: 1,
  //     position: dayjs(now).add(7, 'hour').toISOString(),
  //     file: '2025-06-31T17:00:00.000Z',
  //   };

  //   try {
  //     setLoading(true);
  //     const res = await registerVoucher(body);
  //     if (res?.status) {
  //       notify(
  //         'success',
  //         'Đăng ký thành công, vui lòng kiểm tra email',
  //         'top-center',
  //         7000,
  //       );
  //       setLoading(false);
  //     } else {
  //       notify(
  //         'error',
  //         'Tài khoản của bạn đã được đăng ký trước đây, vui lòng kiểm tra lại',
  //         'top-center',
  //         5000,
  //       );
  //       setLoading(false);
  //     }
  //   } catch (error: any) {
  //     notify('error', error, 'top-center', 5000);
  //     setLoading(false);
  //   }
  // };
  const handleResetForm = () => {
    setInputValue({
      fullName: '',
      email: '',
      phone: '',
      position: renderPositionValue(),
      file: undefined,
    });
  };
  const handleApply = async () => {
    try {
      setLoading(true);
      const form = new FormData();
      form.append('fullName', inputValue.fullName);
      form.append('email', inputValue.email);
      form.append('phone', inputValue.phone);
      form.append('position', inputValue.position as any);
      form.append('file', inputValue.file as any);

      const res = await applyCV(form);

      if (res?.status) {
        notify(
          'success',
          'Ứng tuyển thành công',
          'top-center',
          7000,
        );
        setLoading(false);
        handleResetForm()
      } else {
        notify(
          'error',
          'Có lỗi xảy ra, vui lòng thử lại sau',
          'top-center',
          5000,
        );
        setLoading(false);
        handleResetForm()
      }
    } catch (error: any) {
      notify('error', error, 'top-center', 5000);
      setLoading(false);
      handleResetForm()
    }
  };

  return (
    <div className="career-card-content">
      <p>
        {type === 'dev' && devText1}
        {type === 'data' && dataText}
        {type === 'uxui' && uxText}
        {type === 'business' && businessText}
      </p>
      <p>{type === 'dev' && devText2}</p>

      <div className="career-form">
        <div className="career-form-title">
          Bạn có thể để lại thông tin ứng tuyển cho vị trí này tại đây:
        </div>
        <form className={mapModifiers('p-authorization_section', 'apply-form')}>
          <Input
            placeholder="Nhập họ và tên"
            label="Họ Tên"
            value={inputValue.fullName}
            onChange={(event) => {
              setInputValue({
                ...inputValue,
                fullName: event.target.value,
              });
            }}
            disabled={isLoading}
          />
          <Input
            placeholder="Nhập email"
            label="Email"
            value={inputValue.email}
            onChange={(event) => {
              setInputValue({
                ...inputValue,
                email: event.target.value,
              });
            }}
            disabled={isLoading}
          />
          <Input
            placeholder="Nhập số điện thoại"
            label="SĐT"
            value={inputValue.phone}
            onChange={(event) => {
              setInputValue({
                ...inputValue,
                phone: event.target.value,
              });
            }}
            disabled={isLoading}
          />
          <Input
            placeholder="Nhập vị trí"
            label="Vị trí"
            value={renderPositionValue()}
            disabled
          />

          <Upload
            label="CV (PDF)"
            multiple={false}
            onChange={(info: any) => {
              setInputValue({
                ...inputValue,
                file: info.file,
              });
            }}
            disabled={isLoading}
          />
          <div className="btn-upload">
            <Button
              variant="secondary"
              ariaLabel="Ứng tuyển"
              shape="fill"
              onClick={handleApply}
              loading={isLoading}
            >
              Ứng tuyển
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

const devText1 =
  'Vietstats chào đón những ứng viên có thể giúp chúng tôi xây dựng các ứng dụng web front-end và hệ thống back-end nhằm giải phóng sức mạnh dữ liệu của chúng tôi. Kiến thức về .net core, node.js, python, javaScript và các công nghệ khác sẽ là điều cần thiết.';
const devText2 =
  'Bạn có thể làm việc từ xa hoặc tại văn phòng của Vietstats. Bằng cấp về Khoa học Máy tính hoặc các bằng cấp liên quan đến phát triển web sẽ có giá trị đối với chúng tôi và nó cần được mô tả như một lợi thế trong đơn đăng ký của bạn nhưng không bắt buộc.';
const uxText =
  'Trong vai trò là nhà thiết kế web, bạn sẽ chịu trách nhiệm giúp chúng tôi thiết kế bố cục tổng thể, giao diện người dùng (UI), trải nghiệm người dùng (UX) và tính thẩm mỹ của trang Vietstats.vn. Đây là vị trí đòi hỏi một số kiến thức nhất định trong đó có kiến ​​thức cơ bản về HTML, CSS và Javascript.';
const dataText =
  'Các ứng viên sẽ chịu trách nhiệm thu nhập dữ liệu kinh tế từ các nguồn khác nhau, sau đó xử lý, làm sạch, hệ thống hóa và viết những bình luận ngắn gọn nhưng sâu sắc về các thông tin kinh tế và dữ liệu thị trường. Công việc này đặc biệt phù hợp với những người muốn làm việc từ xa mà không cần đến văn phòng Vietstats. Kiến ​​thức về kinh tế nói chung, đặc biệt là kinh tế vĩ mô, tài chính cùng với một số kỹ năng về phân tích dữ liệu sẽ có giá trị trong đơn đăng ký của bạn nhưng không bắt buộc.';
const businessText =
  'Chúng tôi vui mừng thông báo về việc tuyển dụng các nhà phát triển kinh doanh làm việc trong môi trường có nhiều cơ hội tuyệt vời để tương tác với cơ sở khách hàng đa dạng, từ người dùng cá nhân đến các doanh nghiệp, các chế tài chính, định chế đầu tư, các tập đoàn đa quốc gia, các tổ chức quốc tế, các cơ quan của chính phủ, chính quyền địa phương và các tổ chức xã hội.';
